import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=06089fcc&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06089fcc')) {
      api.createRecord('06089fcc', component.options)
    } else {
      api.reload('06089fcc', component.options)
    }
    module.hot.accept("./complete.vue?vue&type=template&id=06089fcc&lang=pug&", function () {
      api.rerender('06089fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feed_back/complete.vue"
export default component.exports